import React, { useState } from 'react';
import './VisitorTable.css';

const VisitorTable = ({ 
  visitors, 
  onDelete, 
  onEdit, 
  onViewDetails, 
  loading, 
  sendingSMSId, 
  sendingWhatsAppId,
  selectedVisitors = [],
  onSelectVisitor,
  onSelectAll
}) => {
  const [deletingId, setDeletingId] = useState(null);
  
  const isAllSelected = visitors.length > 0 && selectedVisitors.length === visitors.length;

  const handleDelete = async (visitorId, visitorName) => {
    if (window.confirm(`Are you sure you want to delete visitor "${visitorName}"?`)) {
      setDeletingId(visitorId);
      try {
        await onDelete(visitorId);
      } finally {
        setDeletingId(null);
      }
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const getStatusLabel = (status) => {
    switch (String(status)) {
      case '0': return 'Pending';
      case '1': return 'Active';
      case '2': return 'Inactive';
      default: return 'Unknown';
    }
  };

  const getStatusClass = (status) => {
    switch (String(status)) {
      case '0': return 'pending';
      case '1': return 'active';
      case '2': return 'inactive';
      default: return 'unknown';
    }
  };

  if (loading) {
    return <div className="table-loading">Loading visitors...</div>;
  }

  if (!visitors || visitors.length === 0) {
    return (
      <div className="no-visitors">
        <p>No visitors found</p>
      </div>
    );
  }

  return (
    <div className="visitor-table-container">
      <div className="table-responsive">
        <table className="visitor-table">
          <thead>
            <tr>
              {onSelectVisitor && onSelectAll && (
                <th style={{width: '40px'}}>
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={onSelectAll}
                    title="Select all visitors on this page"
                  />
                </th>
              )}
              <th>ID</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Firm</th>
              <th>State/City</th>
              <th>Registration Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {visitors.map((visitor) => (
              <tr key={visitor.id}>
                {onSelectVisitor && (
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedVisitors.includes(visitor.id)}
                      onChange={() => onSelectVisitor(visitor.id)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>
                )}
                <td>{visitor.id}</td>
                <td className="visitor-name-cell">
                  <div className="visitor-name">{visitor.vname || visitor.name || 'N/A'}</div>
                  {visitor.category && (
                    <div className="visitor-firm" style={{fontSize: '0.75rem', color: '#999'}}>{visitor.category}</div>
                  )}
                </td>
                <td>{visitor.vphone || visitor.mobile || 'N/A'}</td>
                <td>{visitor.firm || 'N/A'}</td>
                <td>
                  <div>{visitor.state || 'N/A'}</div>
                  <div style={{fontSize: '0.85rem', color: '#666'}}>{visitor.city || ''}</div>
                </td>
                <td>{formatDate(visitor.ad_date || visitor.reg_date)}</td>
                <td className="actions-cell">
                  <button
                    className="btn btn-view"
                    onClick={() => onViewDetails(visitor.id)}
                    disabled={deletingId === visitor.id}
                    title="View details"
                  >
                    <i className="fas fa-eye"></i>
                  </button>
                  <button
                    className="btn btn-print"
                    onClick={() => window.printVisitor && window.printVisitor(visitor)}
                    disabled={deletingId === visitor.id}
                    title="Print"
                  >
                    <i className="fas fa-print"></i>
                  </button>
                  <button
                    className="btn btn-sms"
                    onClick={() => window.sendSMS && window.sendSMS(visitor)}
                    disabled={deletingId === visitor.id || sendingSMSId === visitor.id}
                    title="Send SMS"
                  >
                    {sendingSMSId === visitor.id ? (
                      <i className="fas fa-spinner fa-spin"></i>
                    ) : (
                      <i className="fas fa-sms"></i>
                    )}
                  </button>
                  <button
                    className="btn btn-whatsapp"
                    onClick={() => window.sendWhatsApp && window.sendWhatsApp(visitor)}
                    disabled={deletingId === visitor.id || sendingWhatsAppId === visitor.id}
                    title="Send WhatsApp"
                  >
                    {sendingWhatsAppId === visitor.id ? (
                      <i className="fas fa-spinner fa-spin"></i>
                    ) : (
                      <i className="fab fa-whatsapp"></i>
                    )}
                  </button>
                  <button
                    className="btn btn-delete"
                    onClick={() => handleDelete(visitor.id, visitor.vname || visitor.name)}
                    disabled={deletingId === visitor.id}
                    title="Delete visitor"
                  >
                    {deletingId === visitor.id ? (
                      <i className="fas fa-spinner fa-spin"></i>
                    ) : (
                      <i className="fas fa-trash"></i>
                    )}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VisitorTable;
